// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"fb10afb6","176":"12830025","496":"3a21ab15","505":"9bab51d5","667":"b217db80","862":"ad3d6f3e"}[chunkId] + ".chunk.js";
};